import AsyncSelect from "react-select/async";
import React, {useCallback, useEffect, useState} from "react";
import {Container} from "aurelia-framework";
import {ChoiceLoader} from "./loader/choice-loader";
import debounce from "debounce-promise";
import "./react-choice-element.less";
import * as _ from "lodash";
import {components} from "react-select";

export const ChoiceElement = (props) => {
    const {config, onChange, preselected} = props;
    const [defaultValue, setDefaultValue] = useState();
    const [loaded, setLoaded] = useState(false);
    const optionalProps = props.placeholder && {
        placeholder: props.placeholder,
    };
    const {multiple} = config;
    const choiceLoader = Container.instance.get(ChoiceLoader);

    const loadOptions = useCallback(
        debounce((inputValue) => {
            console.log("LOAD OPTIONS", inputValue);

            let conditions = _.cloneDeep(config?.conditions ?? {});

            if (inputValue) {
                conditions.search = inputValue;
            }

            return choiceLoader.getChoices(config, conditions);
        }, 500),
        [config]
    );

    const loadPreselectedValue = useCallback(
        debounce(async (inputValue) => {
            console.log("LOAD PRESELECTED", inputValue, config, preselected);

            let conditions = _.cloneDeep(config?.conditions ?? {});

            if (inputValue) {
                conditions.search = inputValue;
            }

            let initialValues = preselected;

            if (!Array.isArray(initialValues)) {
                initialValues = initialValues ? [initialValues] : [];
            }

            try {
                const choices = await choiceLoader.getChoices(config, conditions, initialValues.map(iv => ({
                    modelId: iv.modelId,
                    id: iv.id
                })));

                if (multiple) {

                    if (_.isArray(preselected)) {
                        let found = [];

                        for (let preselectedValue of preselected) {
                            const foundChoice = choices.find((option) => option.value.id === preselectedValue?.id);

                            if (foundChoice) {
                                found.push(foundChoice);
                            }
                        }

                        setDefaultValue(found);
                    }

                } else {
                    const foundChoice = choices.find((option) => option.value.id === preselected?.id);

                    if (foundChoice) {
                        setDefaultValue(foundChoice);
                    }
                }

                setLoaded(true);
            } catch (error) {
                console.error("Error loading choices:", error);
            }
        }, 500),
        [config]
    );

    useEffect(() => {
        loadPreselectedValue()
    }, [config, preselected]);

    const convertValue = useCallback(
        (value) => {
            if (value?.[0]?.value) {
                onChange(value?.map((e) => {
                    return e.value;
                }));
            } else {
                onChange(value?.value);
            }
        },
        [onChange]
    );

    const Option = props => {
        return (
            <components.Option {...props}>
                <div>{props.data.renderLabel ?? props.data.label}</div>
                {(props.data.renderSubLabel ?? props.data?.help ?? null) &&
                    <div style={{fontSize: 9, marginTop: 0}}>{props.data.renderSubLabel ?? props.data.help}</div>}
            </components.Option>
        );
    };

    const SingleValue = props => {
        return (
            <components.SingleValue {...props}>
                <div>{props.data.renderLabel ?? props.data.label}</div>
                {(props.data.renderSubLabel ?? props.data?.help ?? null) &&
                    <div style={{fontSize: 9, marginTop: 0}}>{props.data.renderSubLabel ?? props.data.help}</div>}
            </components.SingleValue>
        );
    };

    return (
        <>
            {!preselected || loaded ? (<AsyncSelect
                className="react-choice-element"
                classNamePrefix="react-choice-element"
                cacheOptions
                defaultOptions
                isClearable
                {...optionalProps}
                styles={{
                    ...(props.styles ?? {}),
                    menuPortal: (base) => ({...base, zIndex: 9999}),
                }}
                components={{Option, SingleValue}}
                defaultValue={defaultValue}
                menuPortalTarget={document.body}
                isMulti={multiple === true}
                loadOptions={loadOptions}
                onChange={convertValue}
            />) : null}
        </>
    );
};
